import script from "./WorkflowShareDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowShareDialog.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowShareDialog.vue?vue&type=style&index=0&id=2ef32ebc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ef32ebc"]])

export default __exports__